import { render } from "./pos.vue?vue&type=template&id=4a09e8dc&scoped=true"
import script from "./pos.vue?vue&type=script&lang=js"
export * from "./pos.vue?vue&type=script&lang=js"

import "./pos.vue?vue&type=style&index=0&id=4a09e8dc&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a09e8dc"]])

export default __exports__